import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0c8dd26&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=d0c8dd26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c8dd26",
  null
  
)

export default component.exports